import { render, staticRenderFns } from "./MinutesContainer.vue?vue&type=template&id=0506fa6c&scoped=true"
import script from "./MinutesContainer.vue?vue&type=script&lang=ts"
export * from "./MinutesContainer.vue?vue&type=script&lang=ts"
import style0 from "./MinutesContainer.vue?vue&type=style&index=0&id=0506fa6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506fa6c",
  null
  
)

export default component.exports